import type { ReactNode } from 'react';
import React from 'react';
import { t } from 'Src/i18n';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Button } from 'Components/frameworks/button/Button';
import { StripButton } from 'Components/frameworks/strip-button/StripButton';
import type { AccommodationOptionPriceProps } from './AccommodationOptionPrice';
import { AccommodationOptionPrice } from './AccommodationOptionPrice';
type Props = {
  children: ReactNode;
  className?: string;
  id: string;
  index: number;
  onSelect: () => void | Promise<any>;
  price: AccommodationOptionPriceProps;
};
export const AccommodationOption = ({
  children,
  className,
  id,
  index = 0,
  onSelect,
  price,
}: Props) => {
  return (
    <div
      className={classnames(
        'relative isolate rounded-12 border-1 border-lightGrey bg-white',
        className,
      )}
      data-testid="AccommodationOption"
      id={id}
    >
      <div className="absolute bottom-full z-1 mx-10">
        <StripButton className="font-sans text-10" height={20}>
          {t('common.proposalLabel')}&nbsp;{index}
        </StripButton>
      </div>

      {children}

      <div
        className="flex items-center justify-end gap-10 border-t-1 border-lightGrey p-20"
        data-testid="AccommodationOption-footer"
      >
        <AccommodationOptionPrice {...price} />
        <Button className="w-auto" data-testid="AccommodationOption-select" onClick={onSelect}>
          {price?.isUpgradableOnline
            ? t('booking.accommodation.moreRooms.selectNewRoom')
            : t('booking.accommodation.upgradeRoom.contactATED')}
        </Button>
      </div>
    </div>
  );
};
